import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ButtonEdit from '../ButtonEdit';
import View from './View';
import Edit from './Edit';
import venuePropType from '../../Constants/venueTypes';
import { venueSearchPropType } from '../../Constants/venueSearchTypes';
import { usStatePropType } from '../Insured/StateField';
import PopoverTrigger from '../Popover';
import manualAddressPropType from '../../Constants/manualAddressTypes';

const Venue = ({
  edit,
  confirm,
  venueInputSelect,
  onSelect,
  enabled,
  confirmed,
  venue,
  validVenue,
  placeId,
  address,
  venueState,
  mobile,
  isValidAddress,
  clearForm,
  hasInput,
  basicCoverageRef,
  scrollToPosition,
  isValidState,
  isValidVenueName,
  hasRegionalTax,
  taxRegions,
  isKentuckyEntity,
  isKentuckyCity,
  kentuckyCity,
  hasLookedUpTax,
  venueSearchReadOnly,
  venueSelectInputOptions,
  venueSearchTypeRadio,
  searchVenueCode,
  venueCodeChecked,
  validVenueCode,
  validManualAddress,
  usStates,
  facilityCode,
  venueCode,
  venueName,
  manualVenueAddress,
  lookupTax,
  lookupUtc,
  setKentuckyCity,
  federalEntity,
  kentuckyStateEntity,
  isBlocked,
  genericServerError,
  searchCountries,
  setIsValidManualVenueAddress,
  setManualAddress,
  updateManualCity,
  setIsKentuckyCity,
  setFormKentuckyCity,
  setHasLookedUpTax,
  setVenueSearchReadOnly,
}) => {
  const code = `${facilityCode} - ${venueCode}`;
  const manualAddress = `${manualVenueAddress.address1}, ${manualVenueAddress.city}, ${manualVenueAddress.state}, ${manualVenueAddress.zip}, ${manualVenueAddress.country}`;
  // Invokes tax lookup on mount
  // to allow revalidation on page reload
  const initialTaxLookup = () => {
    lookupTax(
      manualVenueAddress.state,
      manualVenueAddress.city,
      setIsKentuckyCity,
      setHasLookedUpTax,
      false,
    );
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(initialTaxLookup, []);
  return (
    <div className={`component ${enabled ? 'enabled' : 'disabled'}`}>
      <div className="form-row justify-content-between">
        <div className="col-auto my-auto">
          <h3 className="d-inline-block">Venue</h3>
          <PopoverTrigger
            styleClass="text-dark p-1 pb-2 d-inline popover-trigger"
            content="For events with locations that span multiple addresses (parades, festivals, and walks or runs) use the address of the town or city hall where your location and permit is filed."
          />
        </div>
        <ButtonEdit edit={edit} show={confirmed} />
      </div>
      <div className="card">
        <div className="card-body">
          <Edit
            confirm={confirm}
            onSelect={onSelect}
            show={!confirmed}
            validSearchVenue={
              !!validVenue && !!placeId && isValidAddress() && isValidState()
            }
            validVenueCode={validVenueCode}
            validManualAddress={validManualAddress}
            address={address}
            venueState={venueState}
            isValidAddress={isValidAddress}
            mobile={mobile}
            clearForm={clearForm}
            hasInput={hasInput}
            basicCoverageRef={basicCoverageRef}
            scrollToPosition={scrollToPosition}
            isValidState={isValidState}
            isValidVenueName={isValidVenueName}
            hasRegionalTax={hasRegionalTax}
            taxRegions={taxRegions}
            isKentuckyEntity={isKentuckyEntity}
            venueInputSelect={venueInputSelect}
            venueSelectInputOptions={venueSelectInputOptions}
            venueSearchTypeRadio={venueSearchTypeRadio}
            searchVenueCode={searchVenueCode}
            venueCodeChecked={venueCodeChecked}
            usStates={usStates}
            facilityCode={facilityCode}
            venueCode={venueCode}
            venueName={venueName}
            manualVenueCity={manualVenueAddress.city}
            manualVenueState={manualVenueAddress.state}
            lookupTax={lookupTax}
            lookupUtc={lookupUtc}
            isKentuckyCity={isKentuckyCity}
            setIsKentuckyCity={setIsKentuckyCity}
            hasLookedUpTax={hasLookedUpTax}
            setHasLookedUpTax={setHasLookedUpTax}
            kentuckyCity={kentuckyCity}
            setFormKentuckyCity={setFormKentuckyCity}
            setKentuckyCity={setKentuckyCity}
            federalEntity={federalEntity}
            kentuckyStateEntity={kentuckyStateEntity}
            venueSearchReadOnly={venueSearchReadOnly}
            setVenueSearchReadOnly={setVenueSearchReadOnly}
            isBlocked={isBlocked}
            genericServerError={genericServerError}
            setIsValidManualVenueAddress={setIsValidManualVenueAddress}
            setManualAddress={setManualAddress}
            updateManualCity={updateManualCity}
            searchCountries={searchCountries}
          />
          <View
            show={confirmed}
            venue={venue}
            address={address}
            venueCode={code}
            venueName={manualVenueAddress.companyName}
            manualAddress={manualAddress}
            venueSearchTypeRadio={venueSearchTypeRadio}
          />
        </div>
      </div>
    </div>
  );
};
Venue.propTypes = {
  edit: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  venueInputSelect: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  venue: PropTypes.string.isRequired,
  validVenue: PropTypes.bool.isRequired,
  placeId: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  venueState: PropTypes.string.isRequired,
  mobile: PropTypes.bool.isRequired,
  isValidAddress: PropTypes.func.isRequired,
  clearForm: PropTypes.func.isRequired,
  hasInput: PropTypes.bool.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  basicCoverageRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  isValidState: PropTypes.func.isRequired,
  isValidVenueName: PropTypes.func.isRequired,
  hasRegionalTax: PropTypes.bool.isRequired,
  taxRegions: PropTypes.arrayOf(venuePropType).isRequired,
  isKentuckyEntity: PropTypes.bool.isRequired,
  isKentuckyCity: PropTypes.bool.isRequired,
  kentuckyCity: PropTypes.string.isRequired,
  hasLookedUpTax: PropTypes.bool.isRequired,
  venueSearchReadOnly: PropTypes.bool.isRequired,
  venueSelectInputOptions: PropTypes.arrayOf(venueSearchPropType).isRequired,
  venueSearchTypeRadio: PropTypes.string.isRequired,
  searchVenueCode: PropTypes.func.isRequired,
  venueCodeChecked: PropTypes.bool.isRequired,
  validVenueCode: PropTypes.bool.isRequired,
  validManualAddress: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
  facilityCode: PropTypes.string.isRequired,
  venueCode: PropTypes.string.isRequired,
  venueName: PropTypes.string.isRequired,
  manualVenueAddress: manualAddressPropType.isRequired,
  lookupTax: PropTypes.func.isRequired,
  lookupUtc: PropTypes.func.isRequired,
  setKentuckyCity: PropTypes.func.isRequired,
  federalEntity: PropTypes.string.isRequired,
  kentuckyStateEntity: PropTypes.string.isRequired,
  isBlocked: PropTypes.bool.isRequired,
  genericServerError: PropTypes.bool.isRequired,
  searchCountries: PropTypes.arrayOf(PropTypes.string).isRequired,
  setIsValidManualVenueAddress: PropTypes.func.isRequired,
  setManualAddress: PropTypes.func.isRequired,
  updateManualCity: PropTypes.func.isRequired,
  setIsKentuckyCity: PropTypes.func.isRequired,
  setFormKentuckyCity: PropTypes.func.isRequired,
  setHasLookedUpTax: PropTypes.func.isRequired,
  setVenueSearchReadOnly: PropTypes.func.isRequired,
};

export default Venue;
